import Router from 'vue-router'
import store from '../common/store'
import utils from '../common/utils'

Vue.use(Router)

function getScrollTop() {
    /* 
    苹果、安卓手机中，document.body.scrollTop是有值的,
    桌面端 document.documentElement.scrollTop 有值
    */
    var scrollTop = 0;
    if(utils.clientSystemType.isIOS || utils.clientSystemType.isAndroid){
      scrollTop = document.body.scrollTop;
    }else{
      scrollTop = document.documentElement.scrollTop;
    }
    return scrollTop;
}

function setScrollTop(scroll_top) {
    document.documentElement.scrollTop = scroll_top;
    document.body.scrollTop = scroll_top;
}

const router = new Router({
  mode: 'history',

  saveScrollPosition: true,

  
  // 开发
  // base:'/mag/wap/v1/wap/waphome1',
  
  // 生产
  base:'/mag/wap/v1/wap/waphome', 

  scrollBehavior (to, from, savedPosition) {
    if(savedPosition){
       return savedPosition;
     }else if(to.meta.keepAlive){
       let scrollTop = store.state.common.scrollPos[to.name] || 0;
       setTimeout(() => {
           setScrollTop(scrollTop);
        }, 0);
        return {
          x: 0,
          y: scrollTop
        }
     }
   },

  routes: [

    // 测试用页面
    {
      path: '/test',
      name: 'Test',
      component: function(resolve) {
          require(['@/pages/Test'], resolve)
      },
      meta: {
          title: '测试'
      }
    },
    {
      path: '/',
      name: 'Entry',
      component: function(resolve) {
          require(['@/pages/Home'], resolve)
      },
      redirect: {
        name: 'Index',
      },
      children: [
        {
          path: '/index',
          name: 'Index',
          component: function(resolve) {
              require(['@/pages/index/Index'], resolve)
          },
          alias: '/',
          meta: {
            keepAlive: true,
          }
        },
        {
          path: '/circle',
          name: 'Circle',
          component: function(resolve) {
              require(['@/pages/circle/Index'], resolve)
          },
          meta: {
            keepAlive: true,
          }
        },
        // 显示第三方链接
        {
          path: '/thirdlink1',
          component: function(resolve) {
              require(['@/pages/thirdlink/Page1'], resolve)
          }
        },
        {
          path: '/thirdlink2',
          component: function(resolve) {
              require(['@/pages/thirdlink/Page2'], resolve)
          }
        },
        {
          path: '/thirdlink3',
          component: function(resolve) {
              require(['@/pages/thirdlink/Page3'], resolve)
          }
        },
        {
          path: '/thirdlink4',
          component: function(resolve) {
              require(['@/pages/thirdlink/Page4'], resolve)
          }
        },
        {
          path: '/thirdlink5',
          component: function(resolve) {
              require(['@/pages/thirdlink/Page5'], resolve)
          }
        },
        {
          path: '/wshare',
          name: 'Wshare',
          component: function(resolve) {
              require(['@/pages/wshare/Index'], resolve)
          },
          meta: {
              keepAlive: true
          }
        },
        {
          path: '/find',
          name: 'Find',
          component: function(resolve) {
              require(['@/pages/find/Index'], resolve)
          },
          meta: {
              keepAlive: true
          }
        },
        {
          path: '/user',
          name: 'User',
          component: function(resolve) {
              require(['@/pages/user/Index'], resolve)
          }
        }
      ]
    },

    // 帖子列表
    {
      path: '/circlepostlist',
      name: 'CirclePostList',
      component: function(resolve) {
          require(['@/pages/circle/PostList'], resolve)
      },
      meta: {
        keepAlive: true,
      }
    },

    // 帖子详情
    {
      path: '/circledetail',
      name: 'CircleDetail',
      component: function(resolve) {
          require(['@/pages/circle/Detail'], resolve)
      }
    },

    // 帖子发布
    {
      path: '/circlepost',
      name: 'CirclePost',
      component: function(resolve) {
          require(['@/pages/circle/Post'], resolve)
      },
      meta: {
        title: '发帖'
      }
    },

    // 轻分享圈子主页
    {
      path: '/wsharelist',
      name: 'WshareList',
      component: function(resolve) {
          require(['@/pages/wshare/WshareList'], resolve)
      }
    },

    // 发布动态
    {
      path: '/wsharepost',
      name: 'WsharePost',
      component: function(resolve) {
          require(['@/pages/wshare/Post'], resolve)
      },
      meta: {
        title: '发布动态'
      }
    },

    // 打卡圈列表
    {
      path: '/punchlist',
      name: 'PunchList',
      component: function(resolve) {
          require(['@/pages/wshare/PunchList'], resolve)
      }
    },

    // 热门话题
    {
      path: '/topichot',
      name: 'TopicHot',
      component: function(resolve) {
          require(['@/pages/wshare/TopicHot'], resolve)
      },
      meta: {
        title: '热门话题'
      }
    },

    // 话题首页
    {
      path: '/topicindex',
      name: 'TopicIndex',
      component: function(resolve) {
          require(['@/pages/wshare/TopicIndex'], resolve)
      },
      meta: {
        title: '话题首页'
      }
    },

    // 全部工具
    {
      path: '/alltools',
      name: 'AllTools',
      component: function(resolve) {
          require(['@/pages/find/AllTools'], resolve)
      },
      meta: {
        title: '全部工具'
      }
    },

    // 全部活动
    {
      path: '/allactivities',
      name: 'AllActivities',
      component: function(resolve) {
          require(['@/pages/find/AllActivities'], resolve)
      },
      meta: {
        title: '全部活动'
      }
    },

    // 我的资料
    {
      path: '/mineprofile',
      name: 'MineProfile',
      component: function(resolve) {
          require(['@/pages/user/Profile'], resolve)
      },
      meta: {
        title: '我的'
      }
    },

    // 我的主页
    {
      path: '/userhome',
      name: 'UserHome',
      component: function(resolve) {
          require(['@/pages/user/Home'], resolve)
      },
      meta: {
        title: '我的主页'
      }
    },


    // 粉丝
    {
      path: '/userfans',
      name: 'UserFans',
      component: function(resolve) {
          require(['@/pages/user/Fans'], resolve)
      }
    },

    // 关注
    {
      path: '/userfollows',
      name: 'UserFollows',
      component: function(resolve) {
          require(['@/pages/user/Follows'], resolve)
      }
    },

    // 好友动态
    {
      path: '/friendsdynamic',
      name: 'FriendsDynamic',
      component: function(resolve) {
          require(['@/pages/user/FriendsDynamic'], resolve)
      },
      meta: {
        title: '好友动态'
      }
    },

    //非微信wap端登陆
    {
      path: '/signup',
      name: 'UserSignUp', 
      component: function(resolve){
        require(['@/pages/user/SignUp'], resolve)
      },
      meta: {
        title: '用户注册'
      }
    },
    {
      path: '/userinfo',
      name: 'UserInfo',
      component: function(resolve){
        require(['@/pages/user/UserInfo'], resolve);
      },
      meta: {
        title: '完善资料'
      }
    },
    {
      path: '/login',
      name: 'UserLogin',
      component: function(resolve){
        require(['@/pages/user/Login'], resolve);
      },
      meta: {
        title: '用户登陆'
      }
    },
    // 20180403 王同庆 商家圈
    // 全部商家
    {
      path: "/merchantlist",
      name: "merchantList",
      component: function(resolve){
        require(['@/pages/merchant/list'], resolve);
      },
      meta: {
        title: "全部商家",
      }
    },
    // 商家主页
    {
      path: "/merchant/profile",
      name: "merchantProfile",
      component: function(resolve){
        require(['@/pages/merchant/profile'], resolve);
      },
      meta: {
        title: "商家主页",
      }
    },
    // 商家圈首页
    {
      path: "/merchant/circle",
      name: "merchantCircle",
      component: function(resolve){
        require(['@/pages/merchant/circle'], resolve);
      },
      meta: {
        title: "商家圈",
      }
    },
    // 商家优惠
    {
      path: "/merchant/coupons",
      name: "merchantCoupons",
      component: function(resolve){
        require(['@/pages/merchant/coupons'], resolve);
      },
      meta: {
        title: "所有优惠",
      }
    },
    // 商家圈列表
    {
      path: "/merchant/circlelist",
      name: "merchantCircleList",
      component: function(resolve){
        require(['@/pages/merchant/circlelist'], resolve);
      },
      meta: {
        title: "全部圈子",
      }
    },
    // 商家所有门店
    {
      path: "/merchant/allshop",
      name: "merchantAllShop",
      component: function(resolve){
        require(['@/pages/merchant/allshop'], resolve);
      },
      meta: {
        title: "门店",
      }
    },
    // 商家相册
    {
      path: "/merchant/album",
      name: "merchantAlbum",
      component: function(resolve){
        require(['@/pages/merchant/album'], resolve);
      },
      meta: {
        title: "相册",
      }
    },
    // 专题
    {
      path: "/wshare/topicspecial",
      name: "topicSpeicl",
      component: function(resolve){
        require(['@/pages/wshare/TopicSpecial'], resolve);
      },
      meta: {
        title: "专题",
      }
    },
    // 频道页
    {
      path: "/channel",
      name: "Channel",
      component: function(resolve){
        require(['@/pages/circle/Channel'], resolve);
      }
    },
    
  ]
});

router.beforeResolve((to, from, next) => {
  if (from.name) {
      var scrollTop = getScrollTop();
      store.dispatch('updatePageScrollTop', {
        routeName: from.name,
        scrollPosTop: scrollTop
      })
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js